export const deviceDialNumber = (contactOrPhone) => {
  const rawPhone = typeof contactOrPhone === 'object'
    ? contactOrPhone?.phone
    : contactOrPhone;
  const digits = String(rawPhone || '').replace(/\D/g, '');
  if (digits.length === 10) return `+91${digits}`;
  if (digits.length === 12 && digits.startsWith('91')) return `+${digits}`;
  return null;
};

export const canUseDeviceDial = (contact) => (
  !contact?.registered && !contact?.doNotCall && Boolean(deviceDialNumber(contact))
);

export const formatDialPhone = (value) => {
  const digits = String(value || '').replace(/\D/g, '').slice(-10);
  if (digits.length !== 10) return value || '';
  return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
};
